<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditClaimWorkflow"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="edit"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Edit Claim Workflow</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1"> Name</label>
              <input
                v-model="claimWorkflowToEdit.Name"
                type="text"
                required
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Description</label>
              <textarea
                v-model="claimWorkflowToEdit.Description"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-md w-full"
                rows="4"
                maxlength="500"
                autocorrect="en-US"
              ></textarea>
            </div>
          </div>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div>
              <!-- length ? workflowToReview : tableData -->
              <ve-table
                rowKeyFieldName="Id"
                :fixed-header="true"
                :columns="columns"
                :table-data="tableData.length"
                :rowStyleOption="rowStyleOption"
                :cell-selection-option="cellSelectionOption"
              />
              <p
                v-if="tableData.length == 0"
                class="p-2 text-center text-sm w-full bg-gray-100"
              >
                No workflow users
              </p>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
export default {
  name: "CompanySetupeditClaimflow",
  props: [
    "showEditClaimWorkflow",
    "getWorkflow",
    "claimWorkflowToEdit",
    "reload",
  ],
  components: { Loader },
  data() {
    return {
      currentSequence: null,

      edit_error: null,
      edit_success: null,
      loading: false,
      employees: [],
      departments: [],
      locations: [],
      selectedEmployees: [],
      isOpen: false,
      departmentsToSelect: [],
      branchesToSelect: [],
      branches: [],
      rowStyleOption: {
        clickHighlight: false,
        hoverHighlight: false,
      },
      // submit data
      submitData: [
        // {
        //     rowKey: 0,
        //     field: "",
        //     value: "",
        // },
      ],
      cellSelectionOption: {
        // default true
        enable: false,
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "#",
          width: 50,
          align: "left",

          operationColumn: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            row, column, h;
            return ++rowIndex;
          },
        },
        {
          field: "Approver",
          key: "Approver",
          title: "Claim Workflow Group Users",
          align: "left",
          edit: true,

          renderBodyCell: ({ row, column, rowIndex }, h) => {
            rowIndex, h, row, column;
            return (
              <el-select
                size="small"
                value={row["Approver"]}
                on-input={(val) => {
                  row["Approver"] = val;
                  this.cellDataChange(row, column, val);
                }}
                placeholder=""
              >
                {this.getEmployees.map((employee) => (
                  <el-option value={employee.Fullname}>
                    {employee.Fullname}
                  </el-option>
                ))}
              </el-select>
            );
          },
        },

        {
          field: "SequenceNo",
          key: "sequence",
          title: "Sequence",
          align: "center",
          headerAlign: "right",
          edit: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            rowIndex, h;
            return (
              <el-input-number
                size="small"
                min={0}
                value={row["SequenceNo"]}
                on-input={(val) => {
                  row["SequenceNo"] = val;
                }}
                on-change={(val) => {
                  this.cellDataChange(row, column, val);
                }}
              ></el-input-number>
            );
          },
        },
      ],
      // table data
      tableData: [
        {
          Approver: "",
          SequenceNo: "",
          Id: "",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.tableData = this.claimWorkflowToEdit
      ? this.claimWorkflowToEdit.lines
      : [];
    //console.log(this.tableData)
  },
  methods: {
    // cell data change
    cellDataChange(row, column, cellValue) {
      const { submitData } = this;

      let currentCell = submitData.find(
        (x) => x.rowKey === row["rowKey"] && x.field === column.field
      );

      if (currentCell) {
        currentCell.value = cellValue;
      } else {
        let newCell = {
          rowKey: row["rowKey"],
          field: column.field,
          value: cellValue,
        };
        this.submitData.push(newCell);
      }
    },

    getEmployeeId(id) {
      const userIsNotPresent =
        this.claimWorkflowToEdit.ClaimWorkflowLineRequest.some(
          (user) => user.EmployeeId === id
        );
      const sequenceIsNotPresent =
        this.claimWorkflowToEdit.ClaimWorkflowLineRequest.some(
          (seq) => seq.Sequence === this.currentSequence
        );
      if (!userIsNotPresent && !sequenceIsNotPresent) {
        this.claimWorkflowToEdit.ClaimWorkflowLineRequest.push({
          EmployeeId: id,
          Sequence: this.currentSequence,
        });
      } else {
        this.edit_error = "Sequence or User already exists in the workflow";
      }
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        document.addEventListener("click", this.closeDropdown);
      } else {
        document.removeEventListener("click", this.closeDropdown);
      }
    },
    closeDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
        document.removeEventListener("click", this.closeDropdown);
      }
    },

    close() {
      this.$emit("close");
      this.claimWorkflowToEdit = {
        Name: "",
        Description: "",
        ClaimWorkflowLineRequest: [
          {
            EmployeeId: "",
            Sequence: 0,
          },
        ],
      };
      this.selectedEmployees = [];
    },
    // /{organization}/setup/claim/workflow/header/v1/edit
    edit() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .put(
          `${this.getOrganization}/setup/claim/workflow/header/${this.$ApiVersion}/edit`,
          JSON.stringify(this.claimWorkflowToEdit),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.edit_success = response.data.StatusMessage;
              this.$emit("closeOnSuccess");
              this.claimWorkflowToEdit = {
                Name: "",
                Description: "",
                ClaimWorkflowLineRequest: [
                  {
                    EmployeeId: "",
                    Sequence: 0,
                  },
                ],
              };
              this.selectedEmployees = [];
              setTimeout(() => {
                this.edit_success = null;
                this.close();
                this.reload();
              }, 2500);

              this.getWorkflow();
            } else {
              this.edit_error = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
            setTimeout(() => {
              this.edit_error = null;
            }, 2500);
          }
        );
    },
    getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$store.commit("setEmployees", response.data.Data);

              this.employees = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/setup/department/v1/request
    getDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.departments = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // Find branches in a selected location
    getLocationId(e, locationName) {
      //console.log(locationName);
      const locationId = this.locations.find(
        (location) =>
          location.Name.trim().toLowerCase() ===
          locationName.trim().toLowerCase()
      ).Id;
      this.claimWorkflowToEdit.LocationId = locationId;
      this.getBranchesByLocationId(locationName);
    },

    getBranchesByLocationId(locationName) {
      this.branchesToSelect = this.branches.filter(
        (branch) =>
          branch.Location.trim().toLowerCase() ===
          locationName.trim().toLowerCase()
      );
    },

    // Find locations in a selected branch
    getBranchId(e, branchName) {
      const branchId = this.branches.find(
        (branch) =>
          branch.Name.trim().toLowerCase() === branchName.trim().toLowerCase()
      ).Id;
      this.claimWorkflowToEdit.BranchId = branchId;
      this.getDepartmentsBybranchId(branchId);
    },

    getDepartmentsBybranchId(branchId) {
      this.departmentsToSelect = this.departments.filter(
        (department) => department.BranchId === branchId
      );
      //console.log(this.departmentsToSelect);
    },

    getDepartmentId() {
      //console.log(this.departments);
      const departmentId = this.departments.find(
        (department) =>
          department.BranchId === this.claimWorkflowToEdit.BranchId
      ).DepartmentId;
      this.claimWorkflowToEdit.DepartmentId = departmentId;
    },

    getLocations() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/location/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.locations = response.data.Data;
              this.locations.forEach((v, index) => {
                v.rowKey = `${index + ``}`;
                v.departments = [];
              });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/setup/branch/v1/request
    getBranches() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/branch/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.branches = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.selected-items {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  cursor: pointer;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 0.5rem 0;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 0.375rem 0.375rem;
  overflow-y: auto;
  max-height: 10rem;
}

.dropdown-menu label {
  display: block;
  padding: 0.5rem;
  cursor: pointer;
}

.dropdown-menu input[type="checkbox"] {
  margin-right: 0.5rem;
}

.dropdown-menu label:hover {
  background-color: #f7fafc;
}

.dropdown-menu label:last-of-type {
  margin-bottom: 0;
}

.dropdown-menu::-webkit-scrollbar {
  width: 0.25rem;
}

.dropdown-menu::-webkit-scrollbar-track {
  background-color: #f7fafc;
}

.dropdown-menu::-webkit-scrollbar-thumb {
  background-color: #cbd5e0;
}
</style>
